
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"11.113","height":"5.629"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.706 4.922L5.541.5l4.866 4.422","fill":"none","stroke":"#4e5d6b","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    